import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { HeaderSecondaryMenuButton } from './HeaderSecondaryMenuButton.js';
import { useChatBot } from './useChatBot.js';
export const HeaderChatBotButton = JSX(({ chat = 'personal', iconVersion, className, ariaLabel = 'Чат', version }) => {
    const load = useChatBot(chat);
    return (_jsx(HeaderSecondaryMenuButton, { className: className, image: { icon: 'HeadphonesIcon', iconVersion }, ariaLabel: ariaLabel, onClick: load, buttonSize: "large", isGrayBg: true, version: version }));
});
//# sourceMappingURL=HeaderChatBotButton.js.map